module.exports = __webpack_public_path__ + "static/media/camaro.9ef9c9a5.jpg";